import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config/api';
import './Management.css';

const UserManagement = () => {
  const { token } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [updatingUser, setUpdatingUser] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, [token]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/api/users?populate=role&sort=id:desc`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error('Kan gebruikers niet laden');
      const data = await response.json();
      setUsers(data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = async (userId, newRoleId) => {
    try {
      setUpdatingUser(userId);
      const response = await fetch(`${API_URL}/api/users/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ role: newRoleId }),
      });

      if (!response.ok) throw new Error('Kan gebruikersrol niet bijwerken');
      await fetchUsers();
    } catch (err) {
      setError(err.message);
    } finally {
      setUpdatingUser(null);
    }
  };

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Gebruikersbeheer</h1>
      </div>

      {error && <div className="error-message">{error}</div>}

      {loading ? (
        <p className="loading">Gebruikers worden geladen...</p>
      ) : users.length === 0 ? (
        <p className="empty">Geen gebruikers gevonden</p>
      ) : (
        <div className="items-table">
          <table>
            <thead>
              <tr>
                <th>Naam</th>
                <th>E-mailadres</th>
                <th>Rol</th>
                <th>Lid Sinds</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>
                    <span className="status-badge" style={{ backgroundColor: '#00d9ff' }}>
                      {user.role?.name === 'admin' ? 'Beheerder' : 'Gebruiker'}
                    </span>
                  </td>
                  <td>{new Date(user.createdAt).toLocaleDateString('nl-NL')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
